export const getUserCountry = async () => {
    try {
        const response = await fetch("http://ip-api.com/json/?fields=countryCode");
        const data = await response.json();
        return data.countryCode || "US";
    } catch (error) {
        console.error("Error fetching user location:", error);
        return "US"; 
    }
};